module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_5012.6f79d273.png";